export default __webpack_public_path__ + "static/media/img222.0d11fed2.png";